export default "__VITE_ASSET__DrtPAnvD__"